import React from 'react';
import { uniqueId } from '../../../utils/functions.js';

/*eslint-disable */

var mortgagesIcon = (function (_ref) {
  var alt = _ref.alt,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? uniqueId() : _ref$id;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.009h5.999v-2H0v2zm0 4h5.999v-2H0v2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 .667l-8.233 8.2v10.466h16.466V8.867L10 .667zm6.233 16.666h-3.1v-6.666H6.467v6.666H3.8V9.7L10 3.5l6.233 6.233v7.6zm-7.8 0v-4.666H11.1v4.666H8.433z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 5.991)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "".concat(id, "-mask"),
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-5 10.009h15v-16H-5z",
    mask: "url(#".concat(id, "-mask)")
  }))));
});

export default mortgagesIcon;
